import React from 'react';

const About = () => {
    return (
        <div>
            <div className="hero mt-12 ">
                <div className="hero-content flex-col lg:flex-row-reverse">
                    <img src="https://i.ibb.co/Mg7f9kM/delivery-truck.png" className="max-w-sm rounded-lg shadow-2xl" />
                    <div>
                        <h1 className="text-5xl font-bold">About Us</h1>
                        <p className="py-6">The About Us page of your website is an essential source of information for all who want to know more about your business.We Provide the best car and auto mobile part.  </p>
                        <button className="btn btn-primary">Continue reading</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;